(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[321],{

/***/ 8802:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _button__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6625);


const Another = (param)=>{
    let { instance , url  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "center border p-3",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("dl", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("dt", {
                        children: "Pradžia"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("dd", {
                        children: [
                            " ",
                            instance.startDate
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("dt", {
                        children: "Pabaiga"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("dd", {
                        children: [
                            " ",
                            instance.endDate
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("dt", {
                        children: "Kaina"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("dd", {
                        children: [
                            instance.offers.priceCurrency,
                            instance.offers.price
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("dt", {
                        children: "Kur"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("dd", {
                        children: [
                            " ",
                            instance.courseMode
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_button__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                href: url
            })
        ]
    }, instance.startDate);
};
/* harmony default export */ __webpack_exports__["Z"] = (Another);


/***/ }),

/***/ 6625:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);

const Button = (param)=>{
    let { href  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "mb-10 text-right",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                href: href,
                target: "_blank",
                rel: "noopener noreferrer",
                className: "transition-border self-end rounded-md bg-mustard p-3 text-lg font-bold transition-colors duration-1000 dark:bg-green-500 dark:text-black",
                children: "Registruotis"
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Button);


/***/ }),

/***/ 5002:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
const data = {
    links: {
        freePythonLectureRegistration: "https://forms.gle/BZyWuCnFAUvKbDot5",
        generalRegistrationForm: "https://formfaca.de/sm/QwkYhS7Wm"
    },
    courseTopics: [
        {
            id: "pb",
            name: "Python pradedantiesiems",
            description: "Course for someone",
            price: 400,
            hours: 40
        }
    ],
    courses: [
        {
            isPopular: true,
            id: "p-b",
            name: "Python pradedantiesiems",
            tags: [
                "python",
                "data-analysis",
                "beginner"
            ],
            type: "Dieninis",
            days: "PATKPxx",
            groupSize: [
                8,
                16
            ],
            intensity: 40,
            price: 330,
            hours: 40,
            startDate: "2022-11-21",
            description: "Python yra populiariausia pasaulyje programavimo kalba. Python kodas yra lengvai skaitomas, o taikymo sričių - begalė, įskaitant tinklalapių kūrimą, mašininį mokymąsį, automatizavimą ir t.t. Šis kursas puikiai tinka norintiems įgauti Python programavimo pagrindus ir pasirinkti tolimesnę kryptį.",
            // descriptionExtra:
            //   "Šis kursas yra paremtas partnerių, pagal jį paruošta 500 studentų Vokietijoje.",
            link: "python-beginner",
            active: true,
            // https://schema.org/CourseInstance
            courseInstances: [
                // {
                //   courseMode: "online",
                //   startDate: "2022-11-28",
                //   endDate: "2022-12-02",
                //   isAccessibleForFree: false,
                //   courseWorkload: "40 kontaktinių valandų",
                //   instructor: { "@type": "Person", name: "Aidis Stukas" },
                //   eventAttendanceMode: "online",
                //   organizer: { "@type": "Organization", name: "Pirmas kodas" },
                //   offers: {
                //     "@type": "Offer",
                //     availability: "https://schema.org/InStock",
                //     price: 330,
                //     priceCurrency: "EUR",
                //     // url: "http://www.ticketfly.com/purchase/309433",
                //   },
                //   extraType: "dieninė",
                //   extraTypeEmoji: "🏙️",
                //   extraDayTime: "DD, 09:00-17:00 su pertrauka",
                //   // Todo later
                //   // eventSchedule: {},
                // },
                // {
                //   courseMode: "online",
                //   startDate: "2023-01-23",
                //   endDate: "2023-02-17",
                //   isAccessibleForFree: false,
                //   courseWorkload: "40 kontaktinių valandų",
                //   instructor: { "@type": "Person", name: "Aidis Stukas" },
                //   eventAttendanceMode: "online",
                //   organizer: { "@type": "Organization", name: "Pirmas kodas" },
                //   offers: {
                //     "@type": "Offer",
                //     availability: "https://schema.org/InStock",
                //     price: 330,
                //     priceCurrency: "EUR",
                //     // url: "http://www.ticketfly.com/purchase/309433",
                //   },
                //   extraType: "vakarinė",
                //   extraTypeEmoji: "🌆",
                //   extraDayTime: "DD, 18:00-20:00",
                //   // Todo later
                //   // eventSchedule: {},
                //   order: 2,
                // },
                // {
                //   courseMode: "online",
                //   startDate: "2023-01-28",
                //   endDate: "2022-02-19",
                //   isAccessibleForFree: false,
                //   courseWorkload: "40 kontaktinių valandų",
                //   instructor: { "@type": "Person", name: "Aidis Stukas" },
                //   eventAttendanceMode: "online",
                //   organizer: { "@type": "Organization", name: "Pirmas kodas" },
                //   offers: {
                //     "@type": "Offer",
                //     availability: "https://schema.org/InStock",
                //     price: 330,
                //     priceCurrency: "EUR",
                //     // url: "http://www.ticketfly.com/purchase/309433",
                //   },
                //   extraType: "savaitgalinė",
                //   extraTypeEmoji: "☀️",
                //   extraDayTime: "Šeštadieniais, 10:00-13:00",
                //   // Todo later
                //   // eventSchedule: {},
                //   order: 2,
                // },
                {
                    courseMode: "online",
                    startDate: "2023-03-27",
                    endDate: "2023-04-14",
                    isAccessibleForFree: false,
                    courseWorkload: "40 kontaktinių valandų",
                    instructor: {
                        "@type": "Person",
                        name: "Aidis Stukas"
                    },
                    eventAttendanceMode: "online",
                    organizer: {
                        "@type": "Organization",
                        name: "Pirmas kodas"
                    },
                    offers: {
                        "@type": "Offer",
                        availability: "https://schema.org/InStock",
                        price: 600,
                        priceCurrency: "EUR"
                    },
                    extraType: "dieninė",
                    extraTypeEmoji: "\uD83C\uDFD9️",
                    extraDayTime: "10:00-12:00 darbo dienomis",
                    // Todo later
                    // eventSchedule: {},
                    order: 1
                }
            ],
            position: 1
        },
        {
            id: "p-da",
            name: "Duomenų analizė su Python",
            tags: [
                "python",
                "data-analysis",
                "pandas",
                "machine-learning"
            ],
            type: "Vakarinis",
            days: "PATKPxx",
            intensity: 40,
            price: 800,
            hours: 80,
            startDate: "2022-10-02",
            endDate: "2022-10-20",
            description: "Python programavimo kalba yra lyderė duomenų analizės srityje. Versle Python keičia ir papildo Excel bei kitas duomenų analizės priemonės. Baigę šį kursą galėsite mikliai naršyti, tvarkyti, analizuoti ir pristatyti duomenis su Python. Baigę šį kursą galėsite studijuoti mašininį mokymąsį.",
            link: "duomenu-analitika-su-python",
            active: true,
            position: 2
        },
        {
            id: "p-ds",
            name: "Duomenų mokslas ir mašininis mokymasis su Python",
            tags: [
                "python",
                "data-analysis",
                "pandas",
                "machine-learning"
            ],
            type: "Vakarinis",
            days: "PATKPxx",
            intensity: 40,
            price: 1200,
            hours: 80,
            startDate: "2022-10-02",
            endDate: "2022-10-20",
            description: "Tai žingsnis po duomenų analitikos. Susipažinsime su mašininiu mokymusi. Įvaldysime sklearn biblioteką. Susipažinsime su Xgboost, LightGbm bei neuroninių tinklų bibliotekomis (TensorFlow, Pytorch).",
            link: "masininis-mokymasis-su-python",
            active: true,
            position: 3
        },
        {
            id: "p-wd-be",
            name: "Backend Web dev su Python (Django arba FastAPI)",
            tags: [
                "python",
                "data-analysis",
                "pandas",
                "machine-learning"
            ],
            type: "Vakarinis",
            days: "PATKPxx",
            intensity: 40,
            price: 800,
            hours: 80,
            description: "Norite kurti web aplikacijas? Python turi bent keletą tam skirtų bibliotekų. Šis kursas labiausiai tinka tiems, kurie mėgsta dirbi su duomenimis ir neturi noro gilintis į dizainą ir UX/UI klausimus. Baigę šį kursą galėsite kuri web aplikacijų backend dalį.",
            link: "tinklalapiu-kurimas-su-python",
            active: true,
            position: 4
        },
        {
            id: "p-wd-fs",
            name: "Full stack Web dev su Python ir Javascript (React, Tailwind)",
            tags: [
                "python",
                "data-analysis",
                "pandas",
                "machine-learning"
            ],
            type: "Vakarinis",
            days: "PATKPxx",
            intensity: 40,
            price: 1500,
            hours: 120,
            description: "Full-stackeris žmogus, kuris dažniausiai reikalingas mažoms ir/arba judrioms(agile) kompanijoms. Esant poreikiui galėsite sukurti visą aplikaciją arba galėsite specializuotis į viena iš sričių bet tuo pačiu suprast ką daro kolegos 'kitame gale'.",
            link: "tinklalapiu-kurimas-su-python-ir-react",
            active: true,
            position: 5
        },
        {
            id: "p-ws",
            name: "Web scraping su Python",
            tags: [
                "python",
                "data-analysis",
                "pandas",
                "machine-learning"
            ],
            type: "Vakarinis",
            days: "PATKPxx",
            intensity: 40,
            price: 400,
            hours: 40,
            description: "Dažnas IT projektas priklauso nuo duomenų. Vieša paslaptis, kad didelė dalis kompanijų duomenis tiesiog renka iš interneto. Tai sena praktika, bet besikeičianti kiekvienais metais. Išmoksime įvairių scraping technikų. Baigę kursą galėsite sukurti sprendimą kuris nuolat tvarkingai ir patikimai surenka duomenis iš vieno ar net kelių šaltinių.",
            link: "web-scraping-su-python",
            active: true,
            position: 6
        }
    ]
};
/* harmony default export */ __webpack_exports__["Z"] = (data);


/***/ }),

/***/ 4594:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "OR": function() { return /* binding */ Companies; },
  "SH": function() { return /* binding */ PythonPrerequisite; }
});

// UNUSED EXPORTS: BestPrice, UnderConstruction

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./node_modules/@heroicons/react/24/outline/esm/CurrencyEuroIcon.js


function CurrencyEuroIcon_CurrencyEuroIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M14.25 7.756a4.5 4.5 0 100 8.488M7.5 10.5h5.25m-5.25 3h5.25M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
  }));
}

const ForwardRef = react.forwardRef(CurrencyEuroIcon_CurrencyEuroIcon);
/* harmony default export */ var esm_CurrencyEuroIcon = (ForwardRef);
;// CONCATENATED MODULE: ./node_modules/@heroicons/react/24/outline/esm/ExclamationTriangleIcon.js


function ExclamationTriangleIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z"
  }));
}

const ExclamationTriangleIcon_ForwardRef = react.forwardRef(ExclamationTriangleIcon);
/* harmony default export */ var esm_ExclamationTriangleIcon = (ExclamationTriangleIcon_ForwardRef);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./components/info.jsx



const commonClassGreen = "gap-3 rounded-lg flex  bg-green-100 border border-l-4 border-green-500 text-green-700   px-4 py-1 dark:bg-gray-900 dark:text-green-500   dark:border-green-500";
const commonClassYellow = "gap-3 rounded-lg flex  bg-yellow-100 border border-l-4 border-yellow-500 text-yellow-700  px-4 py-1 dark:bg-stone-900 dark:text-yellow-200  dark:border-yellow-200";
const commonClassOrange = "gap-3 rounded-lg flex  bg-red-100 border border-l-4 border-red-500 text-red-700 2 px-4 py-1 dark:bg-gray-900 dark:text-red-400   dark:border-red-500";
const UnderConstruction = ()=>{
    return /*#__PURE__*/ _jsxs("div", {
        className: commonClassGreen,
        role: "alert",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "basis-1/12",
                children: /*#__PURE__*/ _jsx(InformationCircleIcon, {
                    className: "v-12 h-12"
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                children: "Šiuo metu vyksta atnaujinimo darbai"
            })
        ]
    });
};
const Companies = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: commonClassGreen + " flex flex-col",
        role: "alert",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                className: "text-2xl font-bold",
                children: [
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_CurrencyEuroIcon, {
                        className: "inline h-12"
                    }),
                    " Įmonėms"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    "Ši programa gali būti pritaikyti Jūsų poreikiams.",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/for-companies",
                        children: "Daugiau"
                    })
                ]
            })
        ]
    });
};
const BestPrice = ()=>{
    return /*#__PURE__*/ _jsxs("p", {
        className: commonClassYellow + " flex flex-col",
        role: "alert",
        id: "best-price",
        children: [
            /*#__PURE__*/ _jsxs("span", {
                className: "text-2xl font-bold",
                children: [
                    " ",
                    /*#__PURE__*/ _jsx(CurrencyEuroIcon, {
                        className: "inline h-12"
                    }),
                    " Geriausia kaina"
                ]
            }),
            /*#__PURE__*/ _jsxs("span", {
                children: [
                    " ",
                    "Radote panašią programą už mažesnę kainą? Pirmas kodas pasiruošęs mokymų kainą sumažinti iki Jūsų rastos!"
                ]
            })
        ]
    });
};
const PythonPrerequisite = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: commonClassOrange + " flex flex-col",
        role: "alert",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "text-2xl font-bold",
                children: [
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_ExclamationTriangleIcon, {
                        className: "inline h-12"
                    }),
                    "Reikalingos žinios"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    " ",
                    "Šie mokymai rekomenduojami turintiems Python programavimo kalbos pagrindus. Juos galite įgyti pas mus.",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/courses/python-beginner",
                        children: "Python pradedantiesiems"
                    })
                ]
            })
        ]
    });
};



/***/ }),

/***/ 2076:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Fp": function() { return /* binding */ courseDataToSchema; },
/* harmony export */   "VD": function() { return /* binding */ schemaElementFromSchema; },
/* harmony export */   "aV": function() { return /* binding */ orderByOrder; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4298);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_script__WEBPACK_IMPORTED_MODULE_1__);


const courseDataToSchema = (data, courseId)=>{
    const course = data.courses.filter((course)=>course.id == courseId)[0];
    const schema = ((param)=>{
        let { name , description , courseInstances  } = param;
        return {
            name,
            description,
            courseInstances
        };
    })(course);
    schema["@context"] = "https://schema.org";
    schema["@type"] = "Course";
    schema["provider"] = {
        "@type": "Organization",
        name: "Pirmas kodas",
        sameAs: "https://pirmaskodas.lt"
    };
    return schema;
};
const schemaElementFromSchema = (schema)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_script__WEBPACK_IMPORTED_MODULE_1___default()), {
        id: schema.name,
        type: "application/ld+json",
        dangerouslySetInnerHTML: {
            __html: JSON.stringify(schema)
        }
    });
function orderByOrder(a, b) {
    if (a.order < b.order) {
        return -1;
    }
    if (a.order > b.order) {
        return 1;
    }
    return 0;
}



/***/ }),

/***/ 4298:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(3573)


/***/ })

}]);